import { computed, shallowRef, watch } from 'vue';
import { useStore } from 'vuex';
import { gradingPeriods } from '@/constants/gradingPeriods';

// The term picked on a schedule page. Only a school year graded in terms
// (syType 1: 1st–3rd Term) has a schedule per term; in a quarter year
// `hasTerms` is false, `term` is null and the schedule is the whole year's.
// It always opens on the 1st Term, and goes back to it when the school year
// changes. `termQuery` is the "term=…" to add to schedule requests ('' when
// there are no terms).
export function useTerm() {
  const store = useStore();
  const hasTerms = computed(() => Number(store.getters.getSyType) === 1);
  const terms = computed(() => (hasTerms.value ? gradingPeriods(1) : []));
  const term = shallowRef(terms.value[0] ?? null);
  watch(terms, (list) => {
    if (!list.includes(term.value)) term.value = list[0] ?? null;
  });
  watch(
    () => store.getters.getFilterSelected,
    () => (term.value = terms.value[0] ?? null),
  );
  const termQuery = computed(() => (term.value ? `term=${encodeURIComponent(term.value)}` : ''));
  return { hasTerms, terms, term, termQuery };
}
